<template>
    <div>
        <rkm-area
            no-margin-top
            title="Filtros"
            type="fieldset"
        >
            <rkm-form
                v-if="model"
                ref="RkmForm"
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-date-picker
                            :end-validations="validations.periodo.end"
                            :max-date="additionals.dataAtual"
                            :range-inline="false"
                            :start-validations="validations.periodo.start"
                            end-label="Até"
                            range
                            start-label="Período de"
                            v-model="model.periodo"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="!model.periodo.start || !model.periodo.end"
                            :options="form.servicoTipos"
                            @change="handleServicoTipoChange"
                            default-option-text="Todas"
                            label="Tipo de serviço"
                            show-default-option
                            text-field="descricao"
                            v-model="model.servicoTipoId"
                            value-field='id'
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :disabled="!model.periodo.start || !model.periodo.end"
                            :options="form.processamentoStatus"
                            default-option-text="Todas"
                            label="Status do processamento"
                            show-default-option
                            text-field="descricao"
                            v-model="model.processamentoStatusId"
                            value-field='id'
                        />
                    </rkm-col>

                    <rkm-col
                        class="text-nowrap"
                        cols="auto"
                    >
                        <rkm-button
                            :disabled="!model.periodo.start || !model.periodo.end"
                            :label="false"
                            @click="handleBuscarClick"
                            color="primary"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :disabled="!model.periodo.start || !model.periodo.end"
                            :label="false"
                            @click="handleLimparClick"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <rkm-area
            no-margin-top
            title="Resultado"
        >
            <template v-slot:trailing>
                <rkm-dropdown
                    class="mr-2"
                    color="primary"
                    cols="1"
                    menu-class="auto-scroll"
                    no-caret
                    small
                    title="Colunas"
                    v-rkm-tooltip.hover
                >
                    <template v-slot:button-content>
                        <rkm-icon icon="columns" />
                    </template>

                    <rkm-form-checkbox
                        :indeterminate="indeterminate"
                        @change="handleTodosClick"
                        class="mx-2"
                        v-model="selectedAll"
                    >
                        Todas
                    </rkm-form-checkbox>

                    <rkm-form-checkbox-group
                        :options="optionalColumns"
                        class="mx-2"
                        stacked
                        text-field="label"
                        v-model="selectedColumns"
                        value-field="key"
                    />
                </rkm-dropdown>

                <rkm-button
                    :disabled="itens.length === 0"
                    @click="handleImprimirClick"
                    color="info"
                    small
                    title="Imprimir"
                >
                    <rkm-icon icon="print" />
                </rkm-button>

                <rkm-button
                    :disabled="itens.length === 0"
                    @click="handleExportarClick"
                    color="info"
                    small
                    title="Exportar"
                >
                    <rkm-icon icon="file-export" />
                </rkm-button>
            </template>

            <rkm-table
                :fields="fields"
                :foot-clone="itens.length > 0"
                :items="itens"
                hide-filters
                hide-pagination
                no-footer-sorting
            >
                <template #foot(dataProtocolo)>
                    <span></span>
                </template>

                <template #foot(servicoTipoDescricao)>
                    <span></span>
                </template>

                <template #foot(processamentoStatusDescricao)>
                    <span></span>
                </template>

                <template #foot(protocolo)>
                    <span></span>
                </template>

                <template #foot(quantidade)>
                    <span>{{ getSafely(() => totalizadores.quantidade, 0) }}</span>
                </template>
            </rkm-table>
        </rkm-area>
    </div>
</template>

<script>
// Mixins.
import { error, repository, stringCase, object } from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import { mapActions } from 'vuex'

export default {
    computed: {
        fields() {
            return this.columns.filter(column => (column.fixed || false) || this.selectedColumns.includes(column.key))
        },
        optionalColumns() {
            return this.columns.filter(column => !(column.fixed || false))
        },
        validations() {
            return {
                periodo: {
                    start: { required: true },
                    end: { required: true },
                }
            }
        },
    },
    created() {
        this.repositories = {
            impressao: this.getConectaSusRepository('impressao.farmacia'),
            exportacao: this.getConectaSusRepository('exportacao.farmacia'),
            relatorioSoaBnafar: this.getConectaSusRepository('farmacia.relatorioSoaBnafar'),
        }
    },
    data: () => ({
        additionals: null,
        columns: [
            { key: 'dataProtocolo', label: 'Data', fixed: true },
            { key: 'servicoTipoDescricao', label: 'Tipo de serviço', fixed: true },
            { key: 'processamentoStatusDescricao', label: 'Status do processamento', fixed: true },
            { key: 'protocolo', label: 'Protocolo' },
            { key: 'quantidade', label: 'Quantidade', fixed: true },
        ],
        form: null,
        indeterminate: false,
        itens: [],
        model: null,
        others: { moment },
        selectedAll: true,
        selectedColumns: [
            'protocolo',
        ],
        totalizadores: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.relatorioSoaBnafar.create()
                .then(response => {
                    this.additionals = Object.assign(response.data.additionals)
                    this.form = Object.assign(response.data.form)
                    this.model = Object.assign(response.data.model)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleServicoTipoChange(value) {
            this.form.processamentoStatus = []
            this.model.processamentoStatusId = null

            this.itens = []

            if (value) {
                const startDate = this.others.moment(this.model.periodo.start).format('YYYY-MM-DD')
                const endDate = this.others.moment(this.model.periodo.end).format('YYYY-MM-DD')

                this.getProcessamentoStatus(startDate, endDate, value)
            }
        },
        handleBuscarClick() {
            this.setLoading()

            const request = {
                startDate: this.others.moment(this.model.periodo.start).format('YYYY-MM-DD'),
                endDate: this.others.moment(this.model.periodo.end).format('YYYY-MM-DD'),
                servicoTipoId: this.model.servicoTipoId,
                processamentoStatusId: this.model.processamentoStatusId,
            }

            this.repositories.relatorioSoaBnafar.index(this.camelObjectKeysToSnakeRecursive(request))
                .then(({ data }) => {
                    this.itens = data.protocolos
                    this.totalizadores = data.totalizadores
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleLimparClick() {
            this.form.servicoTipos = []
            this.form.processamentoStatus = []

            this.model.periodo = {
                start: null,
                end: null,
            }

            this.model.servicoTipoId = null
            this.model.processamentoStatusId = null

            this.itens = []
        },
        handleTodosClick(selected) {
            this.selectedColumns = selected ? this.optionalColumns.map(c => c.key) : []
        },
        handleImprimirClick() {
            this.setLoading()

            const request = {
                startDate: this.others.moment(this.model.periodo.start).format('YYYY-MM-DD'),
                endDate: this.others.moment(this.model.periodo.end).format('YYYY-MM-DD'),
                servicoTipoId: this.model.servicoTipoId,
                processamentoStatusId: this.model.processamentoStatusId,
                selectedColumns: this.fields.map(field => ({
                    class: field.class,
                    key: this.camelToSnake(field.key),
                    label: field.label,
                })),
            }

            this.repositories.impressao.relatorioSoaBnafar(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    const content = new Blob([response.data], {type: response.headers['content-type']})
                    const url = URL.createObjectURL(content)
                    const link = document.createElement('a')

                    link.href = url
                    link.target = '_blank'
                    link.click()
                    link.remove()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleExportarClick() {
            this.setLoading()

            const request = {
                startDate: this.others.moment(this.model.periodo.start).format('YYYY-MM-DD'),
                endDate: this.others.moment(this.model.periodo.end).format('YYYY-MM-DD'),
                servicoTipoId: this.model.servicoTipoId,
                processamentoStatusId: this.model.processamentoStatusId,
                selectedColumns: this.fields.map(field => ({
                    class: field.class,
                    key: this.camelToSnake(field.key),
                    label: field.label,
                })),
            }

            this.repositories.exportacao.relatorioSoaBnafar(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    const content = new Blob([response.data], {type: response.headers['content-type']})
                    const url = URL.createObjectURL(content)
                    const link = document.createElement('a')

                    link.href = url
                    link.target = '_blank'
                    link.click()
                    link.remove()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getServicoTipos(startDate, endDate) {
            this.setLoading()

            const request = {
                listar: 'servico-tipos',
                startDate,
                endDate,
            }

            this.repositories.relatorioSoaBnafar.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.servicoTipos = Object.assign(response.data)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getProcessamentoStatus(startDate, endDate, servicoTipoId) {
            this.setLoading()

            const request = {
                listar: 'processamento-status',
                startDate,
                endDate,
                servicoTipoId,
            }

            this.repositories.relatorioSoaBnafar.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.processamentoStatus = Object.assign(response.data)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mounted() {
        this.load()
    },
    mixins: [ error, repository, stringCase, object ],
    watch: {
        'model.periodo': {
            deep: true,
            handler(value) {
                if (value.start && value.end) {
                    const startDate = this.others.moment(value.start).format('YYYY-MM-DD')
                    const endDate = this.others.moment(value.end).format('YYYY-MM-DD')

                    this.getServicoTipos(startDate, endDate)
                }
            },
        },
        selectedColumns(value) {
            this.indeterminate = value.length > 0 && value.length != this.optionalColumns.length
            this.selectedAll = value.length > 0 && value.length == this.optionalColumns.length
        },
    },
}
</script>

<style scoped>
.dropdown >>> .auto-scroll {
    max-height: 400px;
    overflow-y: auto;
    width: 300px;
}
</style>